import React, { useEffect, useState, useContext, useRef } from 'react';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import Typography from '@mui/material/Typography';
import BugReport from '@mui/icons-material/BugReport';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';



import { DataContext } from 'contexts/DataContext';

import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { get, update } from './api';
import { get as getRisks } from '../Risks/api'

const ThreatsContextProbability = () => {
    const dataContext = useContext(DataContext);
    const { t } = useTranslation();
    const [threats, setThreats] = useState([]);
    const [probability, setProbability] = useState({} as any);
    const colors = {      
        '-': '',
        0: '#FFFFFF',
        1: '#2CC937',
        2: '#99C140',
        3: '#E7B417',
        4: '#DB7B2A',
        5: '#CC3232'
      } as any;
    useEffect(() => {
        if(dataContext.loading) return;
        if(!dataContext.currentOrganization) return;
        if(!dataContext.currentAssessment) return;

        getRisks(dataContext.currentAssessment).then((response)=>{
            setThreats(response);
        })
    }, [dataContext.loading,dataContext.currentOrganization,dataContext.currentAssessment]);
    
    return (
        <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
        title={<><Typography variant='pageTitle'>{t('Threats Probability')}</Typography></>} 
        >
        


        <Box sx={{ mt: 0 }}>
        
        {threats.map((threat: any, index:number) => {

        
        return <Paper key={index} sx={{marginTop:1, padding:1}}>
            <Box sx={{margin:1}}>
                <Grid container spacing={2} alignItems='center'>
                    <Grid item xs={1} sx={{textAlign:'center'}}>
                        <Item>         
                            <Typography variant='paperTitle'>{threat.id}</Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={10}>
                        <Item>
                        <Typography variant='paperTitle'>{threat.name}</Typography>
                            <Typography component='div' sx={{fontSize:11}}>
                                <div dangerouslySetInnerHTML={{__html: threat.samples}}></div>
                            </Typography>
                        </Item>
                    </Grid>

                    <Grid item xs={1} sx={{textAlign:'right', paddingRight:4}}>
                        <Item sx={{color:colors[Math.round(threat.context_probability>5?5:threat.context_probability)]}}>
                            {Math.round(threat.context_probability>5?5:threat.context_probability)}
                        </Item>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
        })}

        </Box>




      </AppLayout>
    )
}

export default ThreatsContextProbability;